export default "__VITE_ASSET__n5EKEgO7__"